export const CoSignRequirementReasonArray = ["Other", "LMSW"] as const;
